import { takeLatest, takeEvery, put, call } from "redux-saga/effects";
import apiCall from "../services"
import config from '../config/config.json';


function* getAlert(actions) {

    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        let url = (actions.query === null) ? config.credentials.url + '/backoffice/alarm_notification_rules/' : config.credentials.url + '/backoffice/alarm_notification_rules/' + actions.query

        const response = yield call(apiCall, 'get', url, requestOptions)

        yield put({ type: "ALERT_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "ALERT_RESPONSE", value: error })
    }
}

function* alerts(actions) {

    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        let url = (actions.query === null) ? config.credentials.url + '/backoffice/alarm_notification_rules/?offset=0&limit=' + actions.limit : config.credentials.url + '/backoffice/alarm_notification_rules/' + actions.query

        const response = yield call(apiCall, 'get', url, requestOptions)

        yield put({ type: "GET_ALERTS_LIST", value: response })

    } catch (error) {
        yield put({ type: "GET_ALERTS_LIST", value: error })
    }
}

function* createAlert(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };

        const response = yield call(apiCall, 'POST', config.credentials.url + '/backoffice/alarm_notification_rules/', requestOptions);

        yield put({ type: "CREATE_ALERT_RESPONSE", value: response })
    } catch (error) {
        yield put({ type: "CREATE_ALERT_RESPONSE", value: error })
    }
}

function* editAlert(actions) {

    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };

        const response = yield call(apiCall, 'put', config.credentials.url + '/backoffice/alarm_notification_rules/' + actions.id + '/', requestOptions)

        yield put({ type: "EDIT_ALERT_RESPONSE", value: response })
    } catch (error) {
        yield put({ type: "EDIT_ALERT_RESPONSE", value: error })
    }
}

function* deleteAlert(actions) {

    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };
        const requestOptions = {
            headers: headers
        };

        const response = yield call(apiCall, 'delete', config.credentials.url + '/backoffice/alarm_notification_rules/' + actions.id + '/', requestOptions)
        console.log('%c SAGA / editAlert / response :', 'color: #b37900; background: #fff7e6', response);

        yield put({ type: "DELETE_ALERT_RESPONSE", value: response })
    } catch (error) {
        yield put({ type: "DELETE_ALERT_RESPONSE", value: error })
    }
}

export function* getAlertSaga() {
    yield takeEvery("GET_ALERT", getAlert)
}
export function* getAlertsList() {
    yield takeEvery("GET_ALERTS", alerts)
}
export function* createAlertSaga() {
    yield takeEvery("CREATE_ALERT", createAlert)
}
export function* editAlertSaga() {
    yield takeEvery("EDIT_ALERT", editAlert)
}
export function* deleteAlertSaga() {
    yield takeEvery("DELETE_ALERT", deleteAlert)
}


